import { API } from 'widget/helpers/axios';

const getArticleList = async portalId => {
  return API.get(`/api/v1/help_center/articles?portal_id=${portalId}`);
};

const getArticleListByCategory = async (portalId, categoryId) => {
  return API.get(
    `/api/v1/help_center/category?portal_id=${portalId}&category_id=${categoryId}`
  );
};

const getArticle = async (portalId, articleSlug) => {
  return API.get(
    `/api/v1/help_center/article?portal_id=${portalId}&article_slug=${articleSlug}`
  );
};

const getPortal = async portalId => {
  return API.get(`/api/v1/help_center?portal_id=${portalId}`);
};

const getCategories = async portalId => {
  return API.get(`/api/v1/help_center/categories?portal_id=${portalId}`);
};

export {
  getArticleList,
  getArticleListByCategory,
  getArticle,
  getPortal,
  getCategories,
};
